import { collection, addDoc, serverTimestamp, doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase'; // Adjust path to your Firebase config

export const sendWelcomeEmail = async (studentData, studentId) => {
  try {
    // Fetch the course title using the course ID from studentData
    let courseTitle = "Unknown Course"; // Default value if course not found
    if (studentData.course) {
      const courseDocRef = doc(db, 'courses', studentData.course);
      const courseDoc = await getDoc(courseDocRef);
      if (courseDoc.exists()) {
        courseTitle = courseDoc.data().title; // Fetch the title field
      }
    }
//tempale change
    const emailDoc = await addDoc(collection(db, 'mail'), {
      to: [studentData.email],
      message: {
        subject: 'Welcome! Your Student Account Credentials',
        html: `
          <!DOCTYPE html>
          <html>
          <head>
            <style>
              body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; margin: 0; padding: 0; background-color: #f3e8ff; }
              .container { max-width: 900px; margin: 0 auto; padding: 20px; }
              .header { 
                background: linear-gradient(135deg, #a77bca 0%, #b59cd6 100%); 
                color: white; 
                padding: 30px; 
                text-align: center; 
                border-radius: 10px 10px 0 0; 
              }
              .content { 
                background: #f8f9fa; 
                padding: 30px; 
                border-radius: 0 0 10px 10px; 
              }
              .credentials { 
                background: white; 
                padding: 25px; 
                border-radius: 10px; 
                margin: 20px 0; 
                border-left: 5px solid #667eea; 
                box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              }
              .info-box { 
                background: white; 
                padding: 20px; 
                border-radius: 10px; 
                margin: 20px 0; 
                box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              }
              .btn { 
                display: inline-block; 
                background: linear-gradient(135deg, #a9b6f0 0%, #b889e7 100%); 
                color: white; 
                padding: 15px 30px; 
                text-decoration: none; 
                border-radius: 25px; 
                margin: 15px 0; 
                font-weight: bold;
                text-align: center;
              }
              .security-notice { 
                background: #fff3cd; 
                padding: 20px; 
                border-radius: 10px; 
                border-left: 5px solid #ffc107; 
                margin: 20px 0;
              }
              .footer { 
                text-align: center; 
                color: #666; 
                margin-top: 30px; 
                font-size: 14px; 
              }
              ul, ol { padding-left: 20px; }
              li { margin: 8px 0; }
            </style>
          </head>
          <body>
            <div class="container">
              <div class="header">
                <h1>🎓 Welcome to Our Learning Platform!</h1>
                <h2>INTERSKOOL</h2>
                <p>Your journey begins here</p>
              </div>
              <div class="content">
                <h2>Hello ${studentData.name}! 👋</h2>
                <p><strong>🆔 Student ID:</strong> ${studentId}</p>
                <p>Congratulations! Your student account has been successfully created. We're excited to have you join our learning community.</p>
                
                <div class="credentials">
                  <h3>🔐 Your Login Credentials</h3>
                  <p><strong>📧 Email:</strong> ${studentData.email}</p>
                  <p><strong>🔑 Password:</strong> ${studentData.phone}</p>
                </div>
                
                <div class="info-box">
                  <h3>📚 Your Course Information</h3>
                  <p><strong>📖 Course:</strong> ${courseTitle}</p>
                  <p><strong>🏷️ Category:</strong> ${studentData.category || 'Not specified'}</p>
                </div>
                
                <div style="text-align: center; margin: 30px 0;">
                  <a href="https://internskool-front.vercel.app/authentication" class="btn">
                    🚀 Login to Your Account
                  </a>
                </div>
                
                <div class="security-notice">
                  <h4>🔒 Important Security Information</h4>
                  <ul>
                    <li>Your password is currently set to your phone number</li>
                    <li>Please change your password after your first login</li>
                    <li>Keep your credentials safe and never share them</li>
                    <li>Contact support if you notice any suspicious activity</li>
                  </ul>
                </div>
                
                <div class="info-box">
                  <h4>🎯 Next Steps</h4>
                  <ol>
                    <li>Click the login button above</li>
                    <li>Use your email and phone number to sign in</li>
                    <li>Complete your profile setup</li>
                    <li>Start exploring your courses</li>
                  </ol>
                </div>
              </div>
              <div class="footer">
                <p>This is an automated message. Please do not reply to this email.</p>
                <p>&copy; 2025 INTERSKOOL. All rights reserved.</p>
                <p>🌟 Empowering education, one student at a time</p>
              </div>
            </div>
          </body>
          </html>
        `
      },
      createdAt: serverTimestamp()
    });
    
    //console.log('Welcome email queued successfully with ID:', emailDoc.id);
    return { success: true, emailId: emailDoc.id };
  } catch (error) {
    console.error('Error queuing welcome email:', error);
    return { success: false, error: error.message };
  }
};

// NEW FUNCTION: Send credentials email for existing students
export const sendCredentialsEmail = async (studentData) => {
  try {
    // Fetch the course title using the course ID from studentData
    let courseTitle = "Unknown Course"; // Default value if course not found
    if (studentData.course) {
      const courseDocRef = doc(db, 'courses', studentData.course);
      const courseDoc = await getDoc(courseDocRef);
      if (courseDoc.exists()) {
        courseTitle = courseDoc.data().title; // Fetch the title field
      }
    }

    const emailDoc = await addDoc(collection(db, 'mail'), {
      to: [studentData.email],
      message: {
        subject: 'INTERSKOOL "Your Student Account Credentials"',
        html: `
          <!DOCTYPE html>
          <html>
          <head>
            <style>
              body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; margin: 0; padding: 0; background-color: #f3e8ff; }
              .container { max-width: 900px; margin: 0 auto; padding: 20px; }
              .header { 
                background: linear-gradient(135deg, #a77bca 0%, #b59cd6 100%); 
                color: white; 
                padding: 30px; 
                text-align: center; 
                border-radius: 10px 10px 0 0; 
              }
              .content { 
                background: #f8f9fa; 
                padding: 30px; 
                border-radius: 0 0 10px 10px; 
              }
              .credentials { 
                background: white; 
                padding: 25px; 
                border-radius: 10px; 
                margin: 20px 0; 
                border-left: 5px solid #667eea; 
                box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              }
              .info-box { 
                background: white; 
                padding: 20px; 
                border-radius: 10px; 
                margin: 20px 0; 
                box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              }
              .btn { 
                display: inline-block; 
                background: linear-gradient(135deg, #667eea 0%,rgb(211, 173, 248) 100%); 
                color: white; 
                padding: 15px 30px; 
                text-decoration: none; 
                border-radius: 25px; 
                margin: 15px 0; 
                font-weight: bold;
                text-align: center;
              }
              .security-notice { 
                background: #fff3cd; 
                padding: 20px; 
                border-radius: 10px; 
                border-left: 5px solid #ffc107; 
                margin: 20px 0;
              }
              .footer { 
                text-align: center; 
                color: #666; 
                margin-top: 30px; 
                font-size: 14px; 
              }
              ul { padding-left: 20px; }
              li { margin: 8px 0; }
            </style>
          </head>
          <body>
            <div class="container">
              <div class="header">
                <h1>🔐 Your Login Credentials</h1>
                <h2>INTERSKOOL</h2>
                <p>Access your student account</p>
              </div>
              <div class="content">
                <h2>Hello ${studentData.name}! 👋</h2>
                <p>Here are your current login credentials for accessing your student account.</p>
                
                <div class="credentials">
                  <h3>🔐 Your Login Information</h3>
                  <p><strong>📧 Email:</strong> ${studentData.email}</p>
                  <p><strong>🔑 Password:</strong> ${studentData.phone}</p>
                </div>
                
                <div class="info-box">
                  <h3>📚 Your Account Information</h3>
                  <p><strong>📖 Course:</strong> ${courseTitle}</p>
                  <p><strong>🏷️ Category:</strong> ${studentData.category || 'Not specified'}</p>
                </div>
                
                <div style="text-align: center; margin: 30px 0;">
                  <a href="https://internskool-front.vercel.app/authentication" class="btn">
                    🚀 Login to Your Account
                  </a>
                </div>
                
                <div class="security-notice">
                  <h4>🔒 Security Reminder</h4>
                  <ul>
                    <li>Keep your credentials safe and never share them</li>
                    <li>Consider changing your password after login for better security</li>
                    <li>Contact support immediately if you notice any suspicious activity</li>
                  </ul>
                </div>
              </div>
              <div class="footer">
                <p>This is an automated message. Please do not reply to this email.</p>
                <p>&copy; 2025 INTERSKOOL. All rights reserved.</p>
                <p>🌟 Empowering education, one student at a time</p>
              </div>
            </div>
          </body>
          </html>
        `
      },
      createdAt: serverTimestamp()
    });
    
    //console.log('Credentials email queued successfully with ID:', emailDoc.id);
    return { success: true, emailId: emailDoc.id };
  } catch (error) {
    console.error('Error queuing credentials email:', error);
    return { success: false, error: error.message };
  }
};

// Optional: Monitor email delivery status
export const monitorEmailDelivery = (emailDocId, callback) => {
  const emailRef = doc(db, 'mail', emailDocId);
  
  return onSnapshot(emailRef, (doc) => {
    if (doc.exists()) {
      const delivery = doc.data().delivery;
      if (delivery) {
        callback(delivery.state, delivery);
      }
    }
  });
};
